/*
  KYARNA GLOBAL CART v10
  - Ajax Add to Cart (no page refresh, no redirect, no drawer auto-open)
  - Instant cart count update
  - Sticky ATC on mobile product page
  NOTE: silent add-to-cart click handling now lives in kyarna-global-atc.js.
  This file keeps cart-count refresh + the mobile sticky ATC bar only.
*/

(function (w) {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble, [data-cart-count], #kynav-cart-badge').forEach(function(el) {
      if (el.id === 'kynav-cart-badge') {
        el.textContent = count;
        if (count > 0) el.classList.add('on');
        else el.classList.remove('on');
      } else {
        var span = el.querySelector('span[aria-hidden]') || el;
        if (span) span.textContent = count;
        if (count > 0) el.removeAttribute('hidden');
      }
    });
  }

  function KyarnaRefreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'kyarna-atc', data: { itemCount: cart.item_count } }
        }));
        fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            if (sections['cart-icon-bubble']) {
              var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var nb = doc.querySelector('.cart-count-bubble');
              var ob = document.querySelector('.cart-count-bubble');
              if (nb && ob) { ob.innerHTML = nb.innerHTML; ob.removeAttribute('hidden'); }
            }
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  /* ====================================================
     STICKY ATC (mobile product page) — unchanged
  ==================================================== */
  function initStickyATC() {
    if (w.innerWidth > 749) return;
    var main = document.querySelector('main[data-template]');
    var isProduct = (main && main.getAttribute('data-template') === 'product') ||
                   document.body.classList.contains('template-product');
    if (!isProduct) return;

    var bar = document.getElementById('kpe-sticky');
    var stickyBtn = document.getElementById('kpe-sticky-btn');
    if (!bar || !stickyBtn) return;

    function findATC() {
      return document.querySelector('buy-buttons [name="add"]') ||
             document.querySelector('[name="add"]') ||
             document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    }

    function attachObserver(realBtn) {
      new IntersectionObserver(function (entries) {
        bar.style.display = entries[0].isIntersecting ? 'none' : 'flex';
      }, { threshold: 0 }).observe(realBtn);

      stickyBtn.addEventListener('click', function () {
        var rb = findATC();
        if (rb) rb.click(); // delegates to kyarna-global-atc.js form interceptor
      });
    }

    var existing = findATC();
    if (existing) { attachObserver(existing); return; }

    var mo = new MutationObserver(function (mutations, observer) {
      var btn = findATC();
      if (btn) { observer.disconnect(); attachObserver(btn); }
    });
    mo.observe(document.getElementById('MainContent') || document.body, {
      childList: true, subtree: true
    });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }

  w.KyarnaRefreshCart = KyarnaRefreshCart;
  w.kcolRefreshCart   = KyarnaRefreshCart;
  w.kpeRefreshCart    = KyarnaRefreshCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }

}(window));
